import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Spin, Icon, Button } from 'antd';

import {
  ModalCompanyIcon,
  ModalUserIcon,
  ModalEmployeeIcon,
  ModalFinishIcon,
  ModalErrorIcon,
} from 'components/Icons';

import { submitModalState } from 'shared/constant';

import text from './SubmitModal.translation';
import './SubmitModal.component.style.less';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

export class SubmitModal extends PureComponent {
  renderIcon(stepIcon, iconColor) {
    switch (stepIcon) {
      case 'ModalCompanyIcon':
        return <ModalCompanyIcon color={iconColor} />;
      case 'ModalUserIcon':
        return <ModalUserIcon color={iconColor} />;
      case 'ModalEmployeeIcon':
      default:
        return <ModalEmployeeIcon color={iconColor} />;
    }
  }

  getModalStyle(step) {
    const inactiveColor = '#d9d9d9';
    const activeColor = '#108EE9';
    const errorColor = '#FF5D55';

    let iconColor = '';
    let textStyle = '';
    let loading = '';

    switch (step.status) {
      case submitModalState.NOT_STARTED:
        iconColor = inactiveColor;
        textStyle = 'submit-modal-not-started';
        break;
      case submitModalState.INITIALIZED:
      case submitModalState.ROLLBACK:
        iconColor = activeColor;
        textStyle = 'submit-modal-initialized';
        loading = <Spin indicator={antIcon} />;
        break;
      case submitModalState.SUCCESS:
        iconColor = activeColor;
        textStyle = 'submit-modal-success';
        loading = <ModalFinishIcon />;
        break;
      case submitModalState.FAILED:
      default:
        iconColor = errorColor;
        textStyle = 'submit-modal-error';
        loading = <ModalErrorIcon width={32} height={32} />;
        break;
    }

    return {
      iconColor,
      textStyle,
      loading,
    };
  }

  renderRemarksSuccess = () => {
    const {
      remarksSuccessTitle,
      remarksSuccessDescription,
      remarksSuccessSubDescription,
      remarksCreateAnother,
      resetSubmitModal,
      companyId,
    } = this.props;

    return (
      <div>
        <ModalFinishIcon width={84} height={84} />
        <div className="remarks-error-title">{remarksSuccessTitle}</div>
        <div className="remarks-error-description">
          {remarksSuccessDescription}
        </div>
        <div className="remarks-error-description">
          {!companyId && remarksSuccessSubDescription}
        </div>
        {!companyId && (
          <Button
            type="primary"
            block
            onClick={resetSubmitModal}
            className="retry-button"
          >
            {remarksCreateAnother}
          </Button>
        )}
      </div>
    );
  };

  renderRemarksError = () => {
    const {
      // submitAddCompanyState,
      // submitAddUserState,
      // submitAddEmployeeState,
      steps,
      retryTitle,
      remarksErrorTitle,
      remarksErrorDescription,
    } = this.props;

    let failedStep;
    for (let i = 0; i < steps.length; i += 1) {
      if (steps[i].status === submitModalState.FAILED) {
        failedStep = steps[i];
        break;
      }
    }

    // const [stepAddCompany, stepAddUser, stepAddEmployee] = steps;
    // let errorType = '';
    // let retryLink = '';
    // if (submitAddCompanyState === submitModalState.FAILED) {
    //   errorType = stepAddCompany.title;
    //   retryLink = stepAddCompany.retry;
    // }
    // if (submitAddUserState === submitModalState.FAILED) {
    //   errorType = stepAddUser.title;
    //   retryLink = stepAddUser.retry;
    // }
    // if (submitAddEmployeeState === submitModalState.FAILED) {
    //   errorType = stepAddEmployee.title;
    //   retryLink = stepAddEmployee.retry;
    // }

    return (
      <div>
        <ModalErrorIcon />
        <div className="remarks-error-title">{remarksErrorTitle}</div>
        <div className="remarks-error-description">
          {remarksErrorDescription}:
        </div>
        <div className="remarks-error-description">
          &quot;{failedStep.title}&quot;, Please Try again
        </div>
        <Button
          type="primary"
          block
          onClick={failedStep.retry}
          className="retry-button"
        >
          {retryTitle}
        </Button>
      </div>
    );
  };

  renderRemarks = () => {
    const {
      submitAddCompanyState,
      submitAddUserState,
      submitAddEmployeeState,
    } = this.props;

    if (submitAddEmployeeState === submitModalState.SUCCESS) {
      return this.renderRemarksSuccess();
    }

    if (
      submitAddCompanyState === submitModalState.FAILED ||
      submitAddUserState === submitModalState.FAILED ||
      submitAddEmployeeState === submitModalState.FAILED
    ) {
      return this.renderRemarksError();
    }

    return null;
  };

  render() {
    const { formatMessage } = this.props;
    const remarks = this.renderRemarks();

    return (
      <div className="submit-modal">
        {this.props.steps.map((step, index) => {
          const key = `step${index}`;

          const style = this.getModalStyle(step);

          return (
            <Row
              type="flex"
              align="middle"
              className="modal-submit-row"
              key={key}
            >
              <Col span={2} className="icon-container">
                {this.renderIcon(step.icon, style.iconColor)}
              </Col>
              <Col span={16} className={style.textStyle}>
                {step.title}
              </Col>
              <Col span={6} className="modal-loading-container">
                {style.loading}
              </Col>
            </Row>
          );
        })}
        <Row className="remarks-row">
          <Col>{formatMessage(text.submitModalRemarksTite)}</Col>
        </Row>
        <Row>
          <Col span={18} className="remarks-container">
            {remarks}
          </Col>
        </Row>
      </div>
    );
  }
}

SubmitModal.propTypes = {
  formatMessage: PropTypes.func,
  steps: PropTypes.array.isRequired,
  submitAddCompanyState: PropTypes.string,
  submitAddUserState: PropTypes.string,
  submitAddEmployeeState: PropTypes.string,
  retryTitle: PropTypes.string,
  remarksErrorTitle: PropTypes.string,
  remarksErrorDescription: PropTypes.string,
  remarksSuccessTitle: PropTypes.string,
  remarksSuccessDescription: PropTypes.string,
  remarksSuccessSubDescription: PropTypes.string,
  remarksCreateAnother: PropTypes.string,
  resetSubmitModal: PropTypes.func,
  companyId: PropTypes.string,
};

export default SubmitModal;
